import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
  contentWrap: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
  },
  centerContent: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    height: '100%',
  },
  contentMobile: {
    minWidth: '100%',
    height: '100%',
  },
  title: {
    textAlign: 'center',
    fontSize: 16,
    marginLeft: 24,
  },
  close: {
    fontSize: 15,
    color: theme.palette.text.primary,
    position: 'absolute',
    top: 8,
    left: 8,
  },
  dialog: {
    zIndex: `1300 !important`,
  },
  paper: {
    height: '100vh',
  },
  appBar: {
    position: 'relative',
  },
  toolbar: {
    height: 70,
  },
  titleFull: {
    margin: 0,
    padding: 0,
    lineHeight: 1.2,
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  subTitle: {
    fontSize: 15,
  },
  status: {
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    display: 'flex',
  },
  statusIcon: {
    marginLeft: theme.spacing(2),
  },
  container: {
    padding: theme.spacing(4),
    margin: '0 auto',
  },
  containerMobile: {
    padding: 0,
    width: '100%',
    margin: '0 auto',
  },
  paperMaxWidth: {
    maxWidth: 800,
  },
  paperWidth: {
    width: '80%',
  },
  paperWidthMobile: {
    width: '100%',
  },
  paperHeight: {
    height: '100%',
  },
  barTitle: {
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    textAlign: 'center',
    justifyContent: 'center',
    marginLeft: theme.spacing(2),
  },
  dialogContent: {
    overflowY: 'none',
  },
  dialogTitle: {
    padding: 0,
  },
}));
